;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import {
  isPayPerSession,
  getRefundPolicyHours,
  getRefundPolicyPercent,
} from "../../../../lib/pricing"
import isConsultRequired from "../../../../lib/cohort/isConsultRequired"
import { Cohort, Pricing } from "../types"

const NON_REFUNDABLE_TEXT = "This group is non-refundable."

type Props = {
  cohort: Cohort
  latestPricing: Pricing
}

export default function CancellationPolicy({ cohort, latestPricing }: Props) {
  const refundPolicyHours = getRefundPolicyHours({ paymentObj: latestPricing })
  const refundPolicyPercent = getRefundPolicyPercent({ paymentObj: latestPricing })
  const isPayPerSessionValue = isPayPerSession({ paymentObj: latestPricing })
  const consultRequired = isConsultRequired(cohort)
  let policyText

  if (isPayPerSessionValue) {
    if (refundPolicyHours === 0 && refundPolicyPercent === 100) {
      policyText =
        "You’ll be billed for each session until you cancel your membership."
    } else if (refundPolicyHours === 0 && refundPolicyPercent === 0) {
      policyText = "No fee to cancel until session starts."
    } else {
      policyText = `Cancel without being charged up to ${refundPolicyHours} hours before your session. Late cancellations are charged ${refundPolicyPercent}% of the session cost.`
    }
  } else if (consultRequired) {
    policyText =
      "Cancel anytime before your consult without being charged. No cancellations after your consult."
  } else {
    policyText = NON_REFUNDABLE_TEXT
  }

  return (
    <div className="pb-[33px] ">
      <div className="font-bebas font-bold text-[20px] tracking-[1px] pb-[10px]">
        {isPayPerSessionValue &&
        refundPolicyHours === 0 &&
        refundPolicyPercent === 100
          ? "Membership Policy"
          : "Cancellation Policy"}
      </div>
      <div className={"text-[18px] tracking-[.48px]"}>{policyText}</div>
    </div>
  )
}
